import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = ["data-id"]
const _hoisted_3 = { class: "as-match-item__header" }
const _hoisted_4 = { class: "as-match-item__league" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "as-match-item__time as-match-item__status--normal" }
const _hoisted_8 = { class: "as-t_time_num" }
const _hoisted_9 = { class: "as-match-item__date" }
const _hoisted_10 = { class: "as-match-item__body" }
const _hoisted_11 = { class: "as-match-item__team as-match-item__team-home as-team--home" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "as-match-item__team--name as-match-item__team--home-name" }
const _hoisted_14 = {
  key: 0,
  class: "as-match-item__status"
}
const _hoisted_15 = { class: "as-match-item__team as-match-item__team-away as-team--away" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "as-match-item__team--name as-match-item__team--away-name" }
const _hoisted_18 = {
  key: 0,
  class: "as-match-item__footer"
}
const _hoisted_19 = {
  key: 0,
  class: "as-commentator"
}
const _hoisted_20 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_21 = ["fill"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["xlink:href"]
const _hoisted_24 = ["id", "xlink:href"]
const _hoisted_25 = {
  key: 1,
  class: "as-flag"
}
const _hoisted_26 = { class: "as-flag__team" }
const _hoisted_27 = { class: "as-flag__score-list" }
const _hoisted_28 = {
  key: 2,
  class: "as-flag"
}
const _hoisted_29 = { class: "as-flag__team" }
const _hoisted_30 = { class: "as-flag__score-list" }

import { ref, computed } from "vue";
import MatchEnum from "~src/enums/basketball/MatchEnum";
import OddItem from "~src/modules/home/components/OddItem.vue";
import ProgressBar from "~src/components/matches/ProgressBar.vue";
import type {
  IMatch,
  IOdd,
  ITeam,
  ILeague,
  ICommentator,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamName } from "~src/helpers/basketball";
import { getOddValue } from "~src/helpers/OddHelper";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  match: IMatch;
  odds?: Array<IOdd>;
  oddsOld?: Array<IOdd>;
  teams: Array<ITeam>;
  commentators: Array<ICommentator>;
  competitions: Array<ILeague>;
  isShowFlagHalf: boolean;
  isShowFooter: boolean;
  isH2h: boolean;
  mode?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchItem',
  props: {
    match: {},
    odds: { default: () => [] },
    oddsOld: { default: () => [] },
    teams: {},
    commentators: {},
    competitions: {},
    isShowFlagHalf: { type: Boolean, default: true },
    isShowFooter: { type: Boolean, default: true },
    isH2h: { type: Boolean, default: false },
    mode: { default: "" }
  },
  setup(__props: any) {

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

const odd = computed(() => {
  return props.odds.find((item: IOdd) => item.id === props.match.id);
});

const oddOld = computed(() => {
  return props.oddsOld.find((item: IOdd) => item.id === props.match.id);
});

const isShowOdd = computed(() => {
  let check = false;
  for (const key of [
    "asian_hdp",
    "asian_hdp_home",
    "asian_hdp_away",
    "asian_close",
    "european_home",
    "european_draw",
    "european_away",
    "european_close",
    "over_under_hdp",
    "over",
    "under",
    "over_under_close",
  ] as Array<string>) {
    if (getOddValue(odd.value, oddOld.value, key).value != "") {
      check = true;
    }
    break;
  }

  return check;
});

const competition = computed(() => {
  const compet: any = props.competitions.find(
    (item: ILeague) => item.id === props.match.competition_id
  );

  return compet;
});

const commentator = computed(() => {
  const compet: any = props.commentators.find(
    (item: ICommentator) => item.id === props.match.commentator_id
  );

  return compet;
});

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const homeScoreTotal = computed(() => {
  return homeScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const awayScoreTotal = computed(() => {
  return awayScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const activeIncident = ref(false);
const activeHoverPopup = ref(false);
const activeStatistic = ref("");
let hideTimeout: number | undefined = undefined;

const handleMouseOverPopup = async (event: MouseEvent) => {
  activeHoverPopup.value = true;
};

const handleMouseLeavePopup = async (event: MouseEvent) => {
  activeHoverPopup.value = false;
  activeIncident.value = false;
};

const handleMouseOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "";
};

const handleMouseLeave = () => {
  // Use a timeout to avoid flickering
  setTimeout(() => {
    if (!activeHoverPopup.value) {
      activeIncident.value = false;
    }
  }, 100); // Adjust delay as needed
};

const handleMouseStatisticOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "statistic";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.match.slug,
    title: _ctx.match.title
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["as-match-item", [
        `as-${_ctx.gSportType}`,
        {
          'as-is-hot': _ctx.match.is_hot,
          'as-hide-footer': !_ctx.isShowFooter,
          'as-match-item-sm': screenWidth.value < 360,
          [`as-match-item-${siteName.value}`]: siteName.value,
        },
      ]]),
      "data-id": _ctx.match.id
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (competition.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "as-lazy",
                src: _ctx.getImgUrlBySport('competition', _ctx.match.competition_id),
                alt: 
              competition.value.short_name ? competition.value.short_name : competition.value.name
            ,
                width: "24px",
                height: "24px"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (competition.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getCompetitionShortCode(competition.value)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (
              (_ctx.isH2h ||
                _unref(MatchEnum).LIST_STATUS_PLAYING.includes(_ctx.match.status_id)) &&
              _ctx.match?.match_time_player
            )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onMouseover: handleMouseStatisticOver,
                onMouseleave: handleMouseLeave,
                class: _normalizeClass(`as-icon-haflt ${
              _ctx.match?.match_time_player.status_h2h
                ? 'as-icon-haflt-' + _ctx.match?.match_time_player.status_h2h
                : ''
            }`)
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.match?.match_time_player?.text), 1),
                _createVNode(ProgressBar, { match: _ctx.match }, null, 8, ["match"])
              ], 34))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatLocalTime)(_ctx.match.match_time, "h:mm DD/MM")), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _ctx.getImgUrlBySport('team', _ctx.match.home_team_id),
            alt: _unref(getTeamName)(_ctx.teams, _ctx.match.home_team_id),
            class: "as-match-item__team-logo as-match-item__team-away-logo as-team__logo as-lazy"
          }, null, 8, _hoisted_12),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.home_team_id)), 1)
        ]),
        (_ctx.match.status_id === _unref(MatchEnum).STATUS_NOT_STARTED)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(`as-score-vs as-score-vs__28 as-score-vs__only-text as-score-vs__only-text-${siteName.value}`)
              }, "vs", 2)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onMouseover: handleMouseOver,
              onMouseleave: handleMouseLeave,
              class: "as-match-item__status"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(`as-score-vs as-score-vs__num as-score-vs__28 as-score-vs-${siteName.value}`)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["as-home-score", {
                'as-winner': homeScoreTotal.value > awayScoreTotal.value,
              }])
                }, _toDisplayString(homeScoreTotal.value), 3),
                _cache[0] || (_cache[0] = _createElementVNode("b", null, ":", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["as-away-score", {
                'as-winner': homeScoreTotal.value < awayScoreTotal.value,
              }])
                }, _toDisplayString(awayScoreTotal.value), 3)
              ], 2)
            ], 32)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("img", {
            src: _ctx.getImgUrlBySport('team', _ctx.match.away_team_id),
            alt: _unref(getTeamName)(_ctx.teams, _ctx.match.away_team_id),
            class: "as-match-item__team-logo as-match-item__team-away-logo as-team__logo as-lazy"
          }, null, 8, _hoisted_16),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.away_team_id)), 1)
        ])
      ]),
      (_ctx.isShowFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.match.commentator_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                    _createElementVNode("path", {
                      d: "M15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681Z",
                      fill: 'url(#pattern_' + _ctx.match.id + ')',
                      stroke: "#FFC107"
                    }, null, 8, _hoisted_21),
                    _createElementVNode("defs", null, [
                      _createElementVNode("pattern", {
                        id: 'pattern_' + _ctx.match.id,
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1"
                      }, [
                        _createElementVNode("use", {
                          "xlink:href": `#image__${_ctx.match.id}_${_ctx.match.commentator_id}`,
                          transform: "scale(0.000510204)"
                        }, null, 8, _hoisted_23)
                      ], 8, _hoisted_22),
                      _createElementVNode("image", {
                        id: `image__${_ctx.match.id}_${_ctx.match.commentator_id}`,
                        width: "1960",
                        height: "1960",
                        "xlink:href": commentator.value ? commentator.value.avatar : ''
                      }, null, 8, _hoisted_24)
                    ])
                  ])),
                  _createElementVNode("span", null, _toDisplayString(commentator.value ? commentator.value.name : ""), 1)
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.match.status_id != _unref(MatchEnum).STATUS_NOT_STARTED && _ctx.isShowFlagHalf
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.home_team_id)), 1),
                  _createElementVNode("span", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeScores), (score, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["as-flag__score", {
                'as-flag__score-win': score > _unref(awayScores)[index],
              }])
                      }, _toDisplayString(score), 3))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.match.status_id != _unref(MatchEnum).STATUS_NOT_STARTED && _ctx.isShowFlagHalf
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.away_team_id)), 1),
                  _createElementVNode("span", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(awayScores), (score, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["as-flag__score", {
                'as-flag__score-win': score > _unref(homeScores)[index],
              }])
                      }, _toDisplayString(score), 3))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})